(() => {
  const STORAGE_KEY = 'nura_rewards_access_v1';
  const ACCESS_DAYS = 30;

  const readAccess = () => {
    try {
      const access = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!access || !access.email || !access.order || !access.grantedAt) return null;
      const age = Date.now() - Number(access.grantedAt);
      if (age < 0 || age > ACCESS_DAYS * 86400000) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return access;
    } catch (_) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  };

  const normalizeOrder = (value) => {
    const match = String(value || '').trim().match(/^#?\s*(\d{1,5})$/);
    if (!match) return null;
    const number = Number(match[1]);
    return number >= 1 && number <= 10000 ? number : null;
  };

  const validEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());

  const render = (access) => {
    document.querySelectorAll('[data-nura-vip-protected]').forEach((node) => {
      node.hidden = !access;
    });
    document.querySelectorAll('[data-nura-vip-gate]').forEach((node) => {
      node.hidden = Boolean(access);
    });
    if (!access) return;
    document.querySelectorAll('[data-nura-vip-email]').forEach((node) => {
      node.textContent = access.email;
    });
    document.querySelectorAll('[data-nura-vip-order]').forEach((node) => {
      node.textContent = `#${access.order}`;
    });
  };

  const init = () => {
    render(readAccess());

    document.querySelectorAll('[data-nura-vip-form]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const email = String(new FormData(form).get('purchase_email') || '').trim().toLowerCase();
        const order = normalizeOrder(new FormData(form).get('order_number'));
        const error = form.querySelector('[data-nura-vip-error]');

        if (!validEmail(email)) {
          error.textContent = 'Enter a valid purchase email.';
          error.hidden = false;
          form.querySelector('[name="purchase_email"]').focus();
          return;
        }
        if (!order) {
          error.textContent = 'Enter an order number from 1 to 10000.';
          error.hidden = false;
          form.querySelector('[name="order_number"]').focus();
          return;
        }

        const access = { email, order, grantedAt: Date.now() };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(access));
        render(access);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

    document.querySelectorAll('[data-nura-vip-logout]').forEach((button) => {
      button.addEventListener('click', () => {
        localStorage.removeItem(STORAGE_KEY);
        window.location.assign('/pages/nura-rewards');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
